import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from "react-redux";
import { createEngage } from "@actions";
import { FormEngage } from '@components/teachV2/EngageEdit';
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify';

export default function EngageEditPage() {
  const dispatch = useDispatch();
  const [loadingResult, setLoadingResult] = useState(false)
  const [bookId, setBookId] = useState(null)
  const location = useLocation();
  const dataDetail = JSON.parse(location?.state?.engageDetail)

  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch
  } = useForm({
    defaultValues: {
      name: dataDetail?.topic_name,
      instruction: dataDetail?.ai_instructions_raw,
      statement: dataDetail?.open_conversation,
      model: dataDetail?.gpt_model,
      interactionLanguage: dataDetail?.interaction_language,
      interactionMethod: dataDetail?.interaction_method,
    }
  })

  const handleUpload = async (data, bookId) => {
    let params = {
      action_type: "edit_topic_module",
      module_name: data?.name,
      bot_instruction: data?.instruction,
      opening_statement: data?.statement,
      LLM_model: data?.model,
      topic_id: dataDetail?.topic_id,
      interaction_language: data?.interactionLanguage,
      interaction_method: data?.interactionMethod,
    }

    // Bắt đầu tải kết quả
    setLoadingResult(true);

    dispatch(createEngage(params))
      .then((result) => {
        if (result?.data?.status === 200) {
          toast.success(`Data update successfully !`, {
            position: "top-right"
          });
        }
        setLoadingResult(false);
      })
  };

  const onSubmit = (data) => {
    handleUpload(data, bookId);
  }

  console.log(loadingResult, "loadingResult....");
  return (
    <div className="wrapper -teachV2HomePage">
      <form className="form-platform" onSubmit={handleSubmit(onSubmit)}>
        <FormEngage
          register={register}
          setValue={setValue}
          handleSubmit={handleSubmit}
          control={control}
          watch={watch}
          loadingResult={loadingResult}
          setBookId={setBookId}
          bookId={bookId}
        />
      </form>
    </div>
  )
}